/*
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */

angular.module('zeppelinWebApp').controller('SendPasswordResetCtrl', SendPasswordResetCtrl);

function SendPasswordResetCtrl($scope, $rootScope, $http, $httpParamSerializer, baseUrlSrv, $location, $timeout) {
  'ngInject';

  $scope.sendingEmail = false;
  $scope.passwordResetSent = false;
  $scope.passwordResetParams = {};
  $scope.sendPasswordReset = function() {
    $scope.sendingEmail = true;
    $scope.passwordResetParams.successText = '';
    $scope.passwordResetParams.errorText = '';
    $http({
      method: 'POST',
      url: baseUrlSrv.getRestApiBase() + '/magpie/password-reset',
      headers: {
        'Content-Type': 'application/json',
      },
      data: JSON.stringify({
        'username': $scope.passwordResetParams.userName,
      }),
    }).then(function successCallback(response) {
      $scope.passwordResetParams.successText = 'If an active user exists with that email, ' +
        'we have sent a password reset link';
      $scope.sendingEmail = false;
      $scope.passwordResetSent = true;
    }, function errorCallback(errorResponse) {
      $scope.passwordResetParams.errorText = errorResponse.data.message;
      $scope.sendingEmail = false;
      $scope.passwordResetSent = false;
    });
  };

  /*
   ** $scope.$on functions below
   */
  $scope.$on('initPasswordResetValues', function() {
    $scope.passwordResetParams = {
      userName: '',
      errorText: '',
      successText: '',
    };
    $scope.passwordResetSent = false;
  });
}



// WEBPACK FOOTER //
// ./src/components/send-password-reset/send-password-reset.controller.js